import injectSheet from 'react-jss'
import GlobalMessage from './GlobalMessage'
import styles from './GlobalMessage.styles'

export default injectSheet(styles)(GlobalMessage)
